import React from "react";
import {
  FacebookShareButton,
  HatenaShareButton,
  TwitterShareButton,
} from "react-share";
import * as styles from "../block/block.module.scss";

/**
 * @type {Object} 「UI:atoms - ブロック SNSシェア コンポーネント」DOMです。
 * @return {Object} DOMを返します。
 * @param {String} title （このUIを設置している）コンテンツのタイトルを受け取るための引数です。
 * @param {String} url （このUIを設置している）コンテンツのURLを受け取るための引数です。
 * 
 */

const SnsShareButton = ({ title, url }) => {
  return (
    <>
      <section className={`${styles.snsShare}`}>
        <h2>この記事をシェアする</h2>
        <ul>
          <li key={"sns1"}>
            <FacebookShareButton url={url}>
              <img
                src="https://images.ctfassets.net/mc0chld4pn1r/4r2x7PLKMGwSy7nhwmLBXz/db2df82d63c245f08d14ed161d68b0aa/sns-share-icon-facebook.svg"
                alt="この記事をFacebookにシェアする"
                width="32"
                height="33"
              />
            </FacebookShareButton>
          </li>
          <li key={"sns2"}>
            <TwitterShareButton title={title} url={url}>
              <img
                src="https://images.ctfassets.net/mc0chld4pn1r/2yAo6ZsP84yXr2YuGqvQTX/4b2bcb802fefbc5ca918d827f132b7dc/sns-share-icon-x.svg"
                alt="この記事をXにシェアする"
                width="32"
                height="33"
              />
            </TwitterShareButton>
          </li>
          <li key={"sns3"}>
            <HatenaShareButton url={url}>
              <img
                src="https://images.ctfassets.net/mc0chld4pn1r/4duvxAiZb2QAPFNspeBfZH/4be576141b4481d1d2431b62fa54aed8/sns-share-icon-hatenabookmark.svg"
                alt="このエントリーをはてなブックマークに追加する"
                width="150"
                height="150"
              />
            </HatenaShareButton>
          </li>
        </ul>
      </section>
    </>
  );
};
export default SnsShareButton;
